import { useEffect, useState } from "react";

const useLocalStorageState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    const savedValue = sessionStorage.getItem(key);
    try {
      return savedValue ? JSON.parse(savedValue) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    if (state !== null && state !== undefined) {
      sessionStorage.setItem(key, JSON.stringify(state));
    } else {
      sessionStorage.removeItem(key);
    }
  }, [key, state]);

  return [state, setState];
};

export default useLocalStorageState;
